import F from "@babel/runtime/helpers/esm/extends";
import E from "@babel/runtime/helpers/esm/objectWithoutProperties";
import u from "@babel/runtime/helpers/esm/objectSpread2";
import S from "@babel/runtime/helpers/esm/slicedToArray";
import { sstyled as w } from "@semcore/utils/lib/core/index";
import i from "react";
import N from "classnames";
import { createBaseComponent as C, sstyled as R } from "@semcore/core";
import { useBox as B } from "@semcore/flex-box";
import D from "@semcore/utils/lib/enhances/keyboardFocusEnhance";
import j from "@semcore/utils/lib/propsForElement";
import K from "@semcore/utils/lib/logger";
import { useForkRef as P } from "@semcore/utils/lib/ref";
import $ from "@semcore/utils/lib/hasLabels";
import { useColorResolver as z } from "@semcore/utils/lib/use/useColorResolver";
var O = ["keyboardFocused"], q = (
  /*__reshadow_css_start__*/
  (w.insert(
    /*__inner_css_start__*/
    ".___SIcon_1u886_gg_{display:inline-block;-webkit-user-select:none;-moz-user-select:none;user-select:none;shape-rendering:geometricPrecision;box-sizing:content-box;fill:currentColor;flex-shrink:0;outline:0;color:var(--color_1u886)}.___SIcon_1u886_gg_.__keyboardFocused_1u886_gg_{box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5))}.___SIcon_1u886_gg_.__interactive_1u886_gg_{cursor:pointer}@media (hover:hover){.___SIcon_1u886_gg_.__interactive_1u886_gg_:hover{filter:brightness(.8)}}",
    "1u886_gg_"
  ), {
    __SIcon: "___SIcon_1u886_gg_",
    "--color": "--color_1u886",
    _keyboardFocused: "__keyboardFocused_1u886_gg_",
    _interactive: "__interactive_1u886_gg_"
  })
);
function n(r, c) {
  var d = B(u({
    tag: "svg",
    "data-ui-name": "Icon",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    focusable: r.interactive
  }, r), c), s = S(d, 2), m = s[0], f = s[1], e = r.interactive, g = r.color, p = z(), v = p(g), _ = D()(u({
    disabled: !e
  }, f)), y = _.keyboardFocused, o = E(_, O), b = R(q), l = b.cn("SIcon", {
    "use:color": v,
    interactive: e,
    keyboardFocused: y
  }), k = l.className, h = l.style;
  function x(t) {
    if (o.onKeyDown)
      return o.onKeyDown(t);
    e && o.onClick && (t.key === "Enter" || t.key === " ") && (t.preventDefault(), o.onClick(t));
  }
  var a = i.useRef();
  i.useEffect(function() {
    e && process.env.NODE_ENV !== "production" && K.warn(a.current && !$(a.current), "'aria-label' or 'aria-labelledby' are required props for interactive icons", r["data-ui-name"] || n.displayName);
  }, [e]);
  var I = P(c, a);
  return /* @__PURE__ */ i.createElement(m, F({
    role: e ? "button" : void 0,
    "aria-hidden": e ? void 0 : "true"
  }, j(o), {
    style: Object.assign({}, h, o.style),
    className: N(k, o.className) || void 0,
    onKeyDown: x,
    ref: I
  }));
}
n.displayName = "Icon";
const oe = C(n);
export {
  oe as default
};
